// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ChoiceContext } from '@digitalasset/utility-operator-api-ts-client';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { BurnRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Burn';
import { ContractId } from '@daml/types';
import { useUtilityRegistryApiClient } from '../../../../../contexts/UtilityRegistryApiContext';

export const useAcceptBurnRequestContext: () => UseMutationResult<
  ChoiceContext,
  string,
  {
    burnRequestId: ContractId<BurnRequest>;
  }
> = () => {
  const registryApi = useUtilityRegistryApiClient();

  return useMutation({
    mutationKey: ['acceptBurnRequestContext', registryApi],
    mutationFn: async ({ burnRequestId }) => {
      return registryApi.getBurnRequestAcceptContext(burnRequestId);
    },
  });
};
